import React, { useState } from "react";
import { Link } from "react-router-dom";
import SignUpForm from "./SignUpForm";
import Group from "../../assets/assets/GroupBackground.svg";
import Logo from "../../assets/assets/Nibss-Logo.png";
import POS from "../../assets/assets/background-pos.svg";
import Pay from "../../assets/assets/BackgroundPay.svg";
import Network from "../../assets/assets/network _security.svg";

const SignUp = () => {
  const [active, setActive] = useState({
    signup: true,
    welcome: false,
    final: false,
    network: false,
  });
  const handleSignUpClick = () => {
    setActive({
      ...active,
      signup: true,
      welcome: false,
      final: false,
      network: false,
    });
  };
  const handleWelcomeClick = () => {
    setActive({
      ...active,
      signup: false,
      welcome: true,
      final: false,
      network: false,
    });
  };
  const handleFinalClick = () => {
    setActive({
      ...active,
      signup: false,
      welcome: false,
      final: true,
      network: false,
    });
  };
  const handleFinalNetworkClick = () => {
    setActive({
      ...active,
      signup: false,
      welcome: false,
      final: false,
      network: true,
    });
  };

  return (
    <div className="signup-page">
      <Link to="/">
        <div className="signup-logo">
          <img src={Logo} alt="Nibss" />
        </div>
      </Link>
      <div className="signup-wrap">
        {active.signup ? (
          <div className="signupbg-image">
            <img src={Group} alt="group" />
          </div>
        ) : active.welcome ? (
          <div className="signupbg-image">
            <img src={Pay} alt="group" />
          </div>
        ) : active.final ? (
          <div className="signupbg-image2">
            <img src={POS} alt="group" />
          </div>
        ) : (
          <div className="signupbg-image2">
            <img src={Network} alt="group" />
          </div>
        )}

        <SignUpForm
          goToPage1={handleSignUpClick}
          goToPage2={handleWelcomeClick}
          goToPage3={handleFinalClick}
          goToPage4={handleFinalNetworkClick}
          form1={active.signup}
          form2={active.welcome}
          form3={active.final}
          form4={active.network}
        />
      </div>
    </div>
  );
};

export default SignUp;
